import { useNavigate, useParams } from "react-router-dom";
import { Asterisk, Calendar, People, Person, PersonBadge, Terminal, TerminalDash } from "react-bootstrap-icons";
import { useContext, useState } from "react";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { Spinner } from "react-bootstrap";
import { useEffect } from "react";
import { config } from "../../constants/config";
import UserContext from "../../contexts/UserContext";



export default function ViewConnexion() {
    // states
    let codeconnexion = useParams();
    const { user, logoutUser } = useContext(UserContext);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [fetching, setFetching] = useState(false);
    const [editedstate, setEditedstate] = useState(false);
    const [error, setError] = useState(false);

    const [codecompte, setCodecompte] = useState("");
    const [datedeb, setDateDeb] = useState("");
    const [datefin, setDatefin] = useState("");
    const [nomcompte, setNomcompte] = useState('');
    const [loginompte, setLoginompte] = useState('');
    const [codeprofil, setCodeprofil] = useState("");
    const [libprofil, setLibprofil] = useState("");
    const [identprofil, setIdentprofil] = useState("");
    const [codeesptrav, setCodeEspTrav] = useState("");
    const [libesptrav, setLibesptrav] = useState("");
    const [identesptrav, setIdentesptrav] = useState("");
    const [term, setTerm] = useState("");
    const [adrmac, setAdrmac] = useState("");
    const [adrip, setAdrip] = useState("");
    const [datecrea, setDatecrea] = useState("");
    const [etat, setEtat] = useState("");



    const getConneixon = async () => {
        setLoading(true);

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.secure.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            // body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/connections/${codeconnexion.code}`, requestOptions).then((response) => {
            if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data);
                    if (data?.head) {
                        let body = data?.body?.data[0];

                        setCodecompte(body?.codecompte !== null ? body?.codecompte : "");
                        setDateDeb(body?.datedebconn !== null ? body?.datedebconn.slice(0, 19).replace("T", " à ") : "");
                        setDatefin(body?.datefinconn !== null ? body?.datefinconn.slice(0, 19).replace("T", " à ") : "");
                        setNomcompte(body?.nom !== null ? body?.nom : "");
                        setEtat(body?.etat);
                        setLoginompte(body?.login !== null ? body?.login : "");
                        setCodeprofil(body?.codeprofil !== null ? body?.codeprofil : "");
                        setLibprofil(body?.lib !== null ? body?.lib : "");
                        setIdentprofil(body?.ident !== null ? body?.ident : "");
                        setCodeEspTrav(body?.codeesptrav !== null ? body?.codeesptrav : "");
                        setLibesptrav(body?.libesptrav !== null ? body?.libesptrav : "");
                        setIdentesptrav(body?.identesptrav !== null ? body?.identesptrav : "");
                        setTerm(body?.identterm !== null ? body?.identterm : "");
                        setAdrip(body?.adripconn !== null ? body?.adripconn : "");
                        setAdrmac(body?.adrmacconn !== null ? body?.adrmacconn : "");
                        setDatecrea(body?.datecrea !== null ? body?.datecrea.slice(0, 10) : "");

                        setLoading(false);
                    } else {
                        if (data?.body?.data?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            setError(true);
                            setLoading(false);
                        }
                    }
                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                setError(true);
                setLoading(false);
            }

        }).catch((err) => {
            // console.log("error", err);
            setError(true);
            setLoading(false);
        });
    }

    // comportements
    useEffect(() => {
        getConneixon();
    }, [])

    const handleSubmitEdit = async (e) => {

        e.preventDefault();
    }


    // affichages
    return (
        <div className="container-fluid">
            <h1 className="h4 mb-4 font-weight-bold text_primary">Connexions</h1>
            <div className="row">
                <div className="col-md-12">
                    <div className="card shadow mb-4">
                        <div className="card-header py-3">
                            <button onClick={() => navigate(-1)} data-toggle="tooltip" title="Quitter" data-placement="left" className="btn-shadow ml-3 btn btn-dark btn-sm float-right">
                                <i className="fa fa-reply"></i> <span>Retour</span>
                            </button>
                            {/* {!editedstate && <button onClick={() => setEditedstate(true)}
                                                title="Modifier l'activité" 
                                                className="btn-shadow ml-3 btn btn-success btn-sm float-right">
                                                <i className="fa fa-edit mr-1"></i> <span>Modifier</span>
                                            </button>}
                                            {!editedstate && <button onClick={handleDelete}
                                                title="Supprimer l'activité" 
                                                className="btn-shadow ml-3 btn btn-danger btn-sm float-right">
                                                <i className="fa fa-trash mr-1"></i> <span>Supprimer</span>  {deleting && <Spinner
                                                        as="span"
                                                        animation="border"
                                                        size="sm"
                                                        role="status"
                                                        aria-hidden="true"
                                                />}
                                            </button>} */}
                            <h6 className="m-0 ">Informations de la connexion</h6>
                        </div>
                        <div className="card-body">
                            <form style={{ width: "100%" }} onSubmit={handleSubmitEdit}>
                                <div className="row">
                                    {/* <div className="col-md-4 mb-3">
                                                        <div className="row">
                                                            <div className="col-md-12 mb-2">
                                                                <label htmlFor="logo" className="form-label">Logo du client</label>
                                                                <input className="form-control" type="file" id="logo" onChange={handleLogoChange} />
                                                            </div>
                                                            <div className="col-md-12 mb-1">
                                                                <img alt="" src={photoprev} className="rounded" style={{width: "100%"}} />
                                                            </div>
                                                        </div>
                                                    </div> */}
                                    <div className="col-md-12 mb-3">
                                        <div className="row">
                                            <div className="col-md-6 mb-3">
                                                <label htmlFor="datedeb" className="mb-1">Date début connexion</label>
                                                <div className="input-group flex-nowrap">
                                                    <span className="input-group-text" id="datedeb">
                                                        <Calendar />
                                                    </span>
                                                    <input type="text"
                                                        className="form-control"
                                                        value={datedeb}
                                                        onChange={(e) => setDateDeb(e.target.value)}
                                                        disabled={editedstate ? false : true}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <label htmlFor="datefin" className="mb-1">Date fin connexion</label>
                                                <div className="input-group flex-nowrap">
                                                    <span className="input-group-text" id="datefin">
                                                        <Calendar />
                                                    </span>
                                                    <input type="text"
                                                        className="form-control"
                                                        value={datefin}
                                                        onChange={(e) => setDatefin(e.target.value)}
                                                        disabled={editedstate ? false : true}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-12 mb-3">
                                                <label htmlFor="terminal" className="mb-1">Terminal utilisé</label>
                                                <div className="input-group flex-nowrap">
                                                    <span className="input-group-text" id="terminal">
                                                        <Terminal />
                                                    </span>
                                                    <input type="text"
                                                        className="form-control"
                                                        placeholder="Aucune terminal"
                                                        value={term}
                                                        onChange={(e) => setTerm(e.target.value)}
                                                        disabled={editedstate ? false : true}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-4 mb-3">
                                                <label htmlFor="ip" className="mb-1">Adresse ip du terminal</label>
                                                <div className="input-group flex-nowrap">
                                                    <span className="input-group-text" id="ip">
                                                        <TerminalDash />
                                                    </span>
                                                    <input type="text"
                                                        className="form-control"
                                                        placeholder="Aucune adresse ip"
                                                        value={adrip}
                                                        onChange={(e) => setAdrip(e.target.value)}
                                                        disabled={editedstate ? false : true}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-4 mb-5">
                                                <label htmlFor="datecon" className="mb-1">Date de la connexion</label>
                                                <div className="input-group flex-nowrap">
                                                    <span className="input-group-text" id="datecon">
                                                        <Calendar />
                                                    </span>
                                                    <input type="text"
                                                        className="form-control"
                                                        value={datecrea}
                                                        onChange={(e) => setDatecrea(e.target.value)}
                                                        disabled
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-4 mb-3">
                                                <label htmlFor="etatcpte" className="mb-1">Etat de la connexion</label>
                                                <div className="input-group flex-nowrap">
                                                    <span className={`input-group-text ${etat === 1 ? "bg-success" :
                                                        etat === 2 ? "bg-danger" :
                                                            "bg-light"
                                                        }`
                                                    }
                                                        id="etatcpte"
                                                    >
                                                        <Asterisk />
                                                    </span>
                                                    <input
                                                        disabled
                                                        type="text"
                                                        className={`form-control ${etat === 1 ? "text-white bg-success" :
                                                            etat === 2 ? "text-white bg-danger" :
                                                                "bg-light"
                                                            } 
                                                                        `}
                                                        id="etat"
                                                        value={
                                                            etat === 1 ? "Connexion en cours" :
                                                                etat === 2 ? "Connexion terminée" :
                                                                    ""
                                                        }
                                                        placeholder="Etat de la connexion"
                                                        onChange={(e) => setEtat(e.target.value)}
                                                    />
                                                </div>
                                            </div>


                                            <div className="col-md-12 mb-3">
                                                <h4 className="mb-2">Informations du compte</h4>
                                                <div className="row">
                                                    {/* <div className="col-md-4 mb-3">
                                                                        <div className="row">
                                                                            {editedstate && <div className="col-md-12 mb-2">
                                                                                <label htmlFor="photo" className="form-label">Photo de l'utilisateur</label>
                                                                                <input className="form-control" type="file" id="photo" onChange={handleLogoChange} />
                                                                            </div>}
                                                                            <div className="col-md-12 mb-1">
                                                                                <img alt="" src={photoprev} className="rounded" style={{width: "100%"}} />
                                                                            </div>
                                                                        </div>
                                                                    </div> */}
                                                    <div className="col-md-12 mb-3">
                                                        <div className="row">
                                                            <div className="col-md-6 mb-3">
                                                                <label htmlFor="noms" className="mb-1">Nom de l'utilisateur</label>
                                                                <div className="input-group flex-nowrap">
                                                                    <span className="input-group-text" id="noms">
                                                                        <Person />
                                                                    </span>
                                                                    <input type="text"
                                                                        className="form-control"
                                                                        placeholder="Entrez le nom"
                                                                        value={nomcompte}
                                                                        onChange={(e) => setNomcompte(e.target.value)}
                                                                        disabled={editedstate ? false : true}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6 mb-3">
                                                                <label htmlFor="login" className="mb-1">Login du compte</label>
                                                                <div className="input-group flex-nowrap">
                                                                    <span className="input-group-text" id="login">
                                                                        <Person />
                                                                    </span>
                                                                    <input type="text"
                                                                        className="form-control"
                                                                        placeholder="Entrez prénom"
                                                                        value={loginompte}
                                                                        onChange={(e) => setLoginompte(e.target.value)}
                                                                        disabled={editedstate ? false : true}
                                                                    />
                                                                </div>
                                                            </div>

                                                            <div className="col-md-12 mb-3">
                                                                <label htmlFor="profil" className="mb-1">Profil du compte</label>
                                                                <div className="input-group flex-nowrap">
                                                                    <span className="input-group-text" id="profil">
                                                                        <PersonBadge />
                                                                    </span>
                                                                    <input type="text"
                                                                        className="form-control"
                                                                        value={libprofil}
                                                                        onChange={(e) => setLibprofil(e.target.value)}
                                                                        disabled={editedstate ? false : true}
                                                                    />
                                                                </div>
                                                            </div>
                                                            {/* <div className="col-md-6 mb-3">
                                                                <label htmlFor="esptrav" className="mb-1">Espace de travail du compte</label>
                                                                <div className="input-group flex-nowrap">
                                                                    <span className="input-group-text" id="esptrav">
                                                                        <People />
                                                                    </span>
                                                                    <input type="text"
                                                                        className="form-control"
                                                                        value={libesptrav}
                                                                        onChange={(e) => setLibesptrav(e.target.value)}
                                                                        disabled={editedstate ? false : true}
                                                                    />
                                                                </div>
                                                            </div> */}


                                                        </div>
                                                    </div>
                                                </div>
                                            </div>



                                            {/* <div className="col-md-12 mb-3">
                                                                <label htmlFor="desc" className="mb-1">Description</label>
                                                                <div className="input-group flex-nowrap">
                                                                    <span className="input-group-text" id="desc">
                                                                        <TextParagraph />
                                                                    </span>
                                                                    <textarea 
                                                                        className="form-control" 
                                                                        placeholder="Entrez la description du client"
                                                                        value={desc}
                                                                        onChange={(e) => setDesc(e.target.value)}
                                                                        disabled={editedstate ? false : true}
                                                                    />
                                                                </div>
                                                            </div> */}
                                        </div>
                                    </div>
                                    {editedstate && <div className="col-md-12 mt-2">
                                        <button type="submit"
                                            title="Modifier la connxion"
                                            className="btn-shadow ml-3 btn btn-primary btn-sm float-right"
                                        // disabled={name && desc && client["value"]  && type["value"] ? false : true}
                                        >
                                            <i className="fa fa-check mr-2"></i>
                                            <span>Modifier</span> {fetching && <Spinner
                                                as="span"
                                                animation="border"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"
                                            />}
                                        </button>
                                        <button onClick={() => setEditedstate(false)}
                                            title="Annuler l'opération"
                                            className="btn-shadow ml-3 btn btn-danger btn-sm float-right">
                                            <i className="fa fa-reply mr-1"></i> <span>Annuler</span>
                                        </button>
                                    </div>}
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer />
        </div>
    )
}